import { render, staticRenderFns } from "./Joint.vue?vue&type=template&id=09493452"
import script from "./Joint.vue?vue&type=script&lang=js"
export * from "./Joint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports